





import Vue from 'vue'
import RegisterCodeRegistrationOkasan from '@/components/templates/RegisterCodeRegistrationOkasan.vue'

type Data = {
  companyCode: string;
  registerCode: string;
  errorMessage: string;
};

export default Vue.extend({
  name: 'RegisterCodeRegistration',
  components: {
    'register-code-registration-okasan': RegisterCodeRegistrationOkasan
  },
  data (): Data {
    return {
      companyCode: process.env.VUE_APP_COMPANY_CODE,
      registerCode: '',
      errorMessage: ''
    }
  },
  methods: {
    setErrorMessage (errorMassage: string) {
      this.errorMessage = errorMassage
    },
    changeRegisterCode (registerCode: string) {
      this.registerCode = registerCode
    },
    submit () {
      if (this.errorMessage) {
        return
      }
      this.$store.dispatch('registerCode/register', this.registerCode).then(() => {
        this.$router.push({ name: 'customerregistration' })
      })
    }
  }
})
